import dayjs from "dayjs";
import {
  getMatchesByDate,
  getNearestDate,
  getNearestMatch,
  getTodaysNearestMatch,
} from "../../../mls-horizontal-scoreboard/HorizontalScoreboard/utils";
import { statusTypes } from "../../../mls-match-list/utils";

export function getNearestFeaturedMatch(groupedMatches) {
  const todaysMatch = getTodaysNearestMatch(groupedMatches);

  if (todaysMatch) {
    return todaysMatch;
  }

  const nearestDate = getNearestDate({ dates: groupedMatches });
  const nearestGroupedMatches = getMatchesByDate(groupedMatches, nearestDate);
  const nearestMatch = getNearestMatch(
    nearestGroupedMatches.matches,
    nearestDate
  );

  return nearestMatch;
}

export function groupMatchesByDate(matches, excludedLiveMatches = false) {
  if (!matches?.length) return null;

  const matchesByDate = {};

  matches
    .filter((match) =>
      excludedLiveMatches
        ? match?.status?.abbreviation !== statusTypes.live
        : match
    )
    .forEach((match) => {
      const date = dayjs(match.matchDate).format("MM/DD/YYYY");

      matchesByDate[date] = matchesByDate[date]
        ? [...matchesByDate[date], match]
        : [match];
    });

  return Object.keys(matchesByDate).map((key) => ({
    date: dayjs(key).toDate(),
    matches: matchesByDate[key],
  }));
}
